import React, {useContext} from "react";
import {injectIntl} from "react-intl";

// @mui/material
import {Tooltip} from "@mui/material";

// @mui/icons-material
import {InfoOutlined} from "@mui/icons-material";

// core components
import FormikInput from "components/input/formikInput";

// utils
import {CancellationReasonListContext} from "contexts/CancellationReasonListContext";

/**
 * The reason's cross-platform code.
 *
 * It is what crosses the wire to the eshop, which stores it as-is and renders its label from a
 * translation key — nothing over there enumerates or branches on the value, which is what keeps the
 * reason list editable per organization without a deployment. It must therefore stay stable across
 * organizations: the displayed label may vary, the code never does.
 *
 * Hence the tooltip. The codes already in use are read from the loaded reasons rather than hardcoded
 * here — they are marketplace data, not a front-end enum — so an operator can reuse an existing one
 * instead of inventing a variant the eshop has no translation for.
 */
function CodeField(props) {
    const {intl} = props;

    const {cancellationReasons} = useContext(CancellationReasonListContext);

    const existingCodes = [...new Set(
        (cancellationReasons ?? []).map((reason) => reason.code).filter(Boolean)
    )].sort();

    const label = (
        <>
            {intl.formatMessage({id: 'cancellation_reason.form.label.code'})}
            <Tooltip
                title={
                    existingCodes.length > 0
                        ? (
                            <>
                                <div>{intl.formatMessage({id: 'cancellation_reason.form.field.code.tooltip.title'})}</div>
                                <ul style={{margin: '4px 0 0', paddingLeft: 18}}>
                                    {existingCodes.map((code) => <li key={code}>{code}</li>)}
                                </ul>
                            </>
                        )
                        : intl.formatMessage({id: 'cancellation_reason.form.field.code.tooltip.empty'})
                }
            >
                <InfoOutlined style={{fontSize: 16, marginLeft: 6, verticalAlign: 'text-bottom', cursor: 'help'}} />
            </Tooltip>
        </>
    );

    return (
        <FormikInput
            labelText={label}
            inputProps={
                {
                    name: 'code',
                    type: 'text',
                    placeholder: intl.formatMessage({id: 'cancellation_reason.form.field.code.placeholder'}),
                }
            }
        />
    );
}

export default injectIntl(CodeField);
